export function createDonut(
    scene,
    col,
    row,
    type,
    startY = -100
) {

    const spawnX =
        scene.gridStartX +
        col * scene.cellWidth;


    const donut =
        scene.add.image(
            spawnX,
            startY,
            type.texture
        );


    donut.setOrigin(0.5);

    donut.setDisplaySize(
        scene.cellWidth - 10,
        scene.cellHeight - 10
    );

    donut.originalScale =
        donut.scale;


    donut.setInteractive({
        useHandCursor: true
    });


    // ------------------------------------------------------------
    // IMPORTANT:
    // Do NOT call scene.input.setDraggable(donut).
    // ------------------------------------------------------------


    donut.type =
        type;


    donut.value =
        type.value;


    donut.gridCol =
        col;


    donut.gridRow =
        row;


    // ------------------------------------------------------------
    // Home position.
    //
    // This is the position the donut belongs to once it is
    // sitting in its logical grid cell.
    // ------------------------------------------------------------

    donut.homeX =
        scene.gridStartX +
        col * scene.cellWidth;


    donut.homeY =
        scene.gridStartY +
        row * scene.cellHeight;


    return donut;
}